import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-back\"><path d=\"M1024 512c0 281.6-230.4 512-512 512-281.6 0-512-230.4-512-512s230.4-512 512-512C793.6 0 1024 230.4 1024 512zM70.4 512c0 243.2 198.4 441.6 441.6 441.6 243.2 0 441.6-198.4 441.6-441.6 0-243.2-198.4-441.6-441.6-441.6C268.8 70.4 70.4 268.8 70.4 512zM646.4 313.6 448 512l198.4 198.4c12.8 12.8 12.8 32 0 51.2-12.8 12.8-32 12.8-51.2 0L377.6 537.6C371.2 531.2 364.8 518.4 364.8 512c0-6.4 6.4-19.2 12.8-25.6l217.6-217.6C614.4 256 633.6 256 646.4 268.8 659.2 281.6 659.2 300.8 646.4 313.6z\" p-id=\"36336\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/back.svg
// module id = MSJp
// module chunks = 26